module.exports = __webpack_public_path__ + "fonts/Raleway-ThinItalic.1afbfaa0.ttf";